module.exports = __webpack_public_path__ + "media/packs/images/flags/BR-847b9fef1bf2232f8cf2bc00d5380e8e.png";